// Observe confirmed checkout / payment authorization only. No purchase reporting.
(() => {
  if (window.__autozifeMediaGo39491Bridge) return;
  const state = window.__autozifeMediaGo39491Bridge = { version: 1, attached: false, frames: 0 };
  const seen = new Set(), frames = new WeakSet();
  const checkoutPath = /^\/api\/checkout(?:\/(?:credit|paypal|google|apple))?$/;
  const authorizationPath = /^\/api\/checkout\/(?:paypal\/callback|google\/capture|apple\/capture|payment\/capture)$/;
  function publish(name, detail) {
    const fn = window.Shopify?.analytics?.publish;
    if (typeof fn !== 'function') return;
    const key = name + ':' + detail.checkoutId;
    if (seen.has(key)) return;
    seen.add(key);
    try { Promise.resolve(fn.call(window.Shopify.analytics, name, detail)).catch(() => {}); } catch (_) {}
  }
  function observe(path, response, request) {
    const data = response?.data;
    if (!data || typeof data !== 'object') return;
    if (response.code != null && ![0, 200, '0', '200', '20000'].includes(response.code)) return;
    if (checkoutPath.test(path) && data.checkoutId && Array.isArray(data.cart?.items) && data.cart.items.length) {
      publish('autozife_mg_checkout_started', { source: 'yx_checkout_created', checkoutId: String(data.checkoutId) });
    }
    if (!authorizationPath.test(path)) return;
    // Require an explicit authorization/capture result, never a button or redirect URL.
    const status = String(data.payment?.status || data.paymentStatus || data.status || '').trim().toUpperCase();
    if (!['APPROVED', 'AUTHORIZED', 'CAPTURED', 'COMPLETED', 'SUCCESS', 'SUCCEEDED'].includes(status)) return;
    const checkoutId = data.checkoutId || data.checkout?.id || request?.checkoutId;
    if (checkoutId) publish('autozife_mg_payment_info_submitted', {
      source: 'payment_authorization_confirmed', checkoutId: String(checkoutId), status
    });
  }
  function attachRequest() {
    const request = window.yxRequest || (typeof yxRequest !== 'undefined' ? yxRequest : null);
    if (!request || typeof request.post !== 'function') return false;
    if (request.post.__autozifeMediaGo39491) return true;
    const original = request.post;
    function post() {
      const result = Reflect.apply(original, this, arguments);
      const path = String(arguments[0]), data = arguments[1];
      if (checkoutPath.test(path) || authorizationPath.test(path))
        Promise.resolve(result).then(response => { try { observe(path, response, data); } catch (_) {} }, () => {});
      return result;
    }
    Object.defineProperty(post, '__autozifeMediaGo39491', { value: true });
    request.post = post;
    state.attached = true;
    return true;
  }
  function attachFrame(frame) {
    try {
      const w = frame.contentWindow;
      if (!w || w.location.origin !== location.origin || !/^\/a\/s\/checkout(?:\/|$)/.test(w.location.pathname) || frames.has(w.document)) return;
      frames.add(w.document);
      const original = w.fetch;
      if (typeof original !== 'function') return;
      w.fetch = function(input, options) {
        const result = Reflect.apply(original, this, arguments);
        try {
          const url = new URL(typeof input === 'string' ? input : input.url, w.location.href);
          const path = url.pathname;
          if (url.origin === 'https://us.ouyifyapi.com' && authorizationPath.test(path) && String(options?.method || 'GET').toUpperCase() === 'POST') {
            let checkoutId;
            try { checkoutId = typeof options.body === 'string' ? JSON.parse(options.body).checkoutId : undefined; } catch (_) {}
            Promise.resolve(result).then(response => {
              if (response.ok) response.clone().json().then(body => { try { observe(path, body, { checkoutId }); } catch (_) {} }).catch(() => {});
            }, () => {});
          }
        } catch (_) {}
        return result;
      };
      state.frames++;
    } catch (_) { /* Cross-origin frames are never accessed. */ }
  }
  function scan() { document.querySelectorAll('iframe').forEach(attachFrame); }
  document.addEventListener('load', event => { if (event.target?.tagName === 'IFRAME') attachFrame(event.target); }, true);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
  if (!attachRequest()) {
    let attempts = 0;
    const timer = setInterval(() => { if (attachRequest() || ++attempts >= 120) clearInterval(timer); }, 500);
  }
})();
